import type { IRepoCacheConfig } from "../types";
import { httpWithCache } from "./http-cache";
import { httpNetworkOnly } from "./http-network-only";

export const http = (cacheConfig?: IRepoCacheConfig) => {
  return cacheConfig?.cacheTTL ? httpWithCache(cacheConfig) : httpNetworkOnly;
};
